// nova-premier.component.ts
import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-nova-premier',
  templateUrl: './nova-premier.component.html',
  styleUrls: ['./nova-premier.component.scss']
})
export class NovaPremierComponent {
  constructor(private dialogRef: MatDialogRef<NovaPremierComponent>) {}

  close(): void {
    this.dialogRef.close();
  }
}
